export function makeBodyVisible() {
  setTimeout(() => {
    document.body.style.visibility = 'visible'
  }, 200)
}
